
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { rtoLoadsTbl } from '../Models/LoadsData';
import { RtoDemandService } from './rto-demand.service';

@Injectable({
  providedIn: 'root'
})
export class RtoDemandResolverService implements Resolve<Array<rtoLoadsTbl>> {
  RtoloadsData: Observable<Array<rtoLoadsTbl>>;
  constructor(private rtoLoadDemandSvc: RtoDemandService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<rtoLoadsTbl>> | Promise<Array<rtoLoadsTbl>> | Array<rtoLoadsTbl> {
    this.RtoloadsData= this.rtoLoadDemandSvc.GetRtoLoadDemand();
    return this.RtoloadsData;
  }
}